import { Accordion, AccordionDetails, AccordionSummary, Avatar, Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Fab, List, ListItem, ListItemAvatar, ListItemText, Typography, makeStyles } from '@material-ui/core';
import { Add, Close } from '@material-ui/icons';
import { localizeCurrency } from 'util/localizeFormat';
import { NestedContent } from './NestedContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import isEmpty from 'lodash.isempty';
import { fmtColor } from 'util/format';
import ReactJson from 'react-json-view';
import { Waypoint } from 'react-waypoint';
import { useMemo, useRef, useState } from 'react';
import { useTrackEvent } from 'util/trackEvent';
import { stepState } from 'pages/CustomerBookingCreate/state';
import { useRecoilState } from 'recoil';
import { useHistory } from 'react-router-dom';
import { STEP_SERVICE_BREAKDOWN, STEP_SERVICE_DETAILS, STEP_SERVICE_PACKAGES } from 'pages/CustomerBookingCreate/constants';
import { AddToCartButton, DisabledFabButton, LabTestAddButton } from 'components/OverlayButtons/AddToCart';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },
  dialogContent: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    "&>img": {
      objectFit: "cover",
      width: 'inherit',
    }
  },
  topBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: 'transparent'
  },
  bottomBar: {
    bottom: 0,
    backgroundColor: theme.palette.background.paper,
    justifyContent: 'center',
  },
  button: {
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    fontWeight: 'bolder'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: (props) => fmtColor(props.header_text_color),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),

  },
  preroot: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    height: 150,
    color: (props) => fmtColor(props.header_text_color),
    '&>img': {
      height: 150 + theme.mixins.toolbar.minHeight,
      position: 'absolute',
      right: 0,
      bottom: 0,
    }
  },
  iconAvatar: {
    objectFit: 'contain',
  },
  tag: {
    fontWeight: 'bold',
  }
}));
const ProductContentDialog = ({ item,
  onClose = () => { },
  onSelect = async (item) => { },
  isExtendedPackage = false,
  redirectLink,
  baseFee = 0,
  isSelected = false,
  onRemove = (item) => { },
  canAddToCart = true,
  inCart = false,
}) => {
  const styleProps = {
    header_start_color: item?.header_start_color,
    header_end_color: item?.header_end_color,
    header_text_color: item?.header_text_color,
  }
  const classes = useStyles(styleProps)
  const trackEvent = useTrackEvent()

  const [collapsedHeader, setCollapsedHeader] = useState(false);

  const renderNonExtended = useMemo(
    () => {
      if (item?.not_available || item?.fillOptions?.disabled) {
        return (
          <Typography variant="button" className={classes.main}>
            Not Available
          </Typography>
        )
      }

      if (inCart) {
        let cartTitle = 'In cart'
        switch (redirectLink) {
          case STEP_SERVICE_DETAILS:
            cartTitle = 'Select Tests'
            break;
          case STEP_SERVICE_BREAKDOWN:
            cartTitle = 'Checkout Cart'
            break;
          case STEP_SERVICE_PACKAGES:
            cartTitle = 'View other Packages'
            break;
          default:
            break;
        }

        return (
          <Typography variant="button" className={classes.main}>
            {cartTitle}
          </Typography>
        )
      }

      if (!canAddToCart) {
        return (
          <Typography variant="button" className={classes.main}>
            Cannot add to cart
          </Typography>
        )
      }

      return (
        <div className={classes.button}>
          <Typography variant="button" className={classes.main}>
            {item?.fillOptions?.disabled ? 'Coming soon' : item?.action_label}
          </Typography>
          {
            item?.action_type !== 'BOOK_SELECT_TESTS' && (
              <Typography variant="body2" className={classes.pricetag}>
                {localizeCurrency(item?.fee_grand_total)}
              </Typography>
            )
          }
        </div>
      )

    }, [item, canAddToCart, redirectLink]
  );

  const isCartButtonDisabled = useMemo(
    () => {
      return !canAddToCart || item?.not_available || item?.fillOptions?.disabled
    }, []
  );

  const [step, setStep] = useRecoilState(stepState);
  const history = useHistory()

  const [loading, setLoading] = useState(false);
  const renderActionButton = useMemo(
    () => {
      let ADCButton = 'BOOK_SELECT_TESTS' === item?.action_type ? LabTestAddButton : AddToCartButton
      if (item?.not_available || item?.fillOptions?.disabled) {
        ADCButton = DisabledFabButton
      }
      return (
        <ADCButton
          onClick={async () => {
            setLoading(true)
            if (inCart && redirectLink) {
              onClose()
              setStep(redirectLink)
              history.replace(redirectLink, { internal: true })
            } else {
              inCart ? onClose() : await onSelect(item)
            }
            setLoading(false)
          }}
          variant="contained"
          color="primary"
          disabled={isCartButtonDisabled || loading}
          startIcon={loading ? <CircularProgress color="inherit" size={20} /> : null}
          classes={{

          }}
        >
          {renderNonExtended}
        </ADCButton>
      )

    }, [inCart, redirectLink, item, loading]
  );

  const scrollNode = useRef(null);

  const [saveScrollCoords, setSaveScrollCoords] = useState(null);
  return (
    <>
      <DialogActions className={classes.topBar}
      >
        <div className={classes.header}>
          <Typography variant="h3">
            {item.label}
          </Typography>
          <Typography variant="h6">
            {item?.header_description}
          </Typography>
        </div>
        <Fab
          onClick={onClose}
          size="small"
          color="secondary"
          aria-label="close">
          <Close />
        </Fab>
      </DialogActions>
      <DialogContent className={classes.root} ref={scrollNode}>
        {/* <ReactJson src={item} collapsed={2} sortKeys/> */}
        {item?.tags?.filter(tag => !isEmpty(tag?.label))?.length > 0 && (
          <div className={classes.preroot}>
            <List dense>
              {item?.tags?.filter(tag => !isEmpty(tag?.label))?.map((tag, index) => (
                <ListItem key={index}>
                  <ListItemAvatar>
                    <Avatar className={classes.iconAvatar} variant='square' src={tag.icon_url} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className={classes.tag} >
                        {tag.label}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
            <img src={item?.icon_url} />
          </div>
        )}
        {/* <Waypoint
          onLeave={()=>{setCollapsedHeader(true)}}
          onEnter={()=>{setCollapsedHeader(false)}} 
        /> */}
        <div className={classes.dialogContent}>
          <NestedContent 
            root={item?.featured_content}
            onResetScroll={() => {
              scrollNode.current.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
              })
            }}
            onRestoreScroll={() => {
              scrollNode.current.scrollTo({
                top: saveScrollCoords?.y,
                left: saveScrollCoords?.x,
                behavior: 'instant'
              })
            }}
            saveScrollCoords={()=> {
              setSaveScrollCoords({
                x: scrollNode.current.scrollLeft,
                y: scrollNode.current.scrollTop
              })
            }}

          />
        </div>
      </DialogContent>
      <DialogActions
        className={classes.bottomBar}>
        {isExtendedPackage ? (
          <AddToCartButton
            onClick={async () => {
              setLoading(true)
              if (isSelected) {
                onRemove(item)
              } else {
                await onSelect(item)
              }
              setLoading(false)
            }}
            variant="contained"
            color={isSelected ? "secondary" : "primary"}
            classes={{

            }}
            disabled={loading}
            startIcon={loading && <CircularProgress color="inherit" size={20} />}

          >
            <div className={classes.button}>
              <Typography variant="button" className={classes.main}>
                {isSelected ? 'Remove from cart' : 'Add to cart'}
              </Typography>
              {(!isSelected && item?.action_type !== 'BOOK_SELECT_TESTS') &&
                <Typography variant="body2" className={classes.pricetag}>
                  {localizeCurrency(item?.fee + baseFee)}
                </Typography>
              }
            </div>
          </AddToCartButton>
        ) :
          renderActionButton
        }
      </DialogActions>
    </>

  )
}

export { ProductContentDialog };
